
import Navbar from '../visa-travel-tips/components/Navbar';
import Footer from '../visa-travel-tips/components/Footer';

export default function MoneySavingTips() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-green-600 to-emerald-600 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Mẹo tiết kiệm khi du lịch Mỹ
            </h1>
            <p className="text-xl text-green-100 mb-8 max-w-3xl mx-auto">
              Những bí quyết giúp bạn tiết kiệm chi phí mà vẫn có trải nghiệm tuyệt vời
            </p>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors">Trang chủ</a>
            <span>/</span>
            <a href="/visa-travel-tips" className="hover:text-teal-600 transition-colors">Kinh nghiệm du lịch</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Mẹo tiết kiệm</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Introduction */}
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-8 mb-8">
            <p className="text-lg leading-relaxed text-gray-700 mb-0">
              Du lịch Mỹ không nhất thiết phải tốn kém. Với những mẹo tiết kiệm thông minh dưới đây, 
              bạn có thể giảm đáng kể chi phí mà vẫn có được những trải nghiệm tuyệt vời. 
              Từ việc săn vé máy bay giá rẻ đến cách chọn chỗ ở và ăn uống tiết kiệm.
            </p>
          </div>

          {/* Vé máy bay */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-flight-takeoff-line text-green-600"></i>
              Mẹo săn vé máy bay giá rẻ
            </h2>
            
            <div className="bg-white border-l-4 border-green-600 p-6 mb-6">
              <h3 className="text-xl font-semibold mb-4">⏰ Thời điểm đặt vé tốt nhất</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <div>
                    <strong>Đặt trước 2-3 tháng:</strong> Tiết kiệm được 20-30% so với đặt gần ngày bay
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <div>
                    <strong>Bay giữa tuần:</strong> Thứ Ba, Thứ Tư thường rẻ hơn cuối tuần 15-25%
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <div>
                    <strong>Tránh mùa cao điểm:</strong> Tránh Thanksgiving, Giáng sinh, mùa hè
                  </div>
                </li>
              </ul>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-3">🔍 Công cụ so sánh giá</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Google Flights - Theo dõi giá linh hoạt</li>
                  <li>• Skyscanner - So sánh nhiều hãng</li>
                  <li>• Momondo - Tìm vé ẩn</li>
                  <li>• Kayak - Dự đoán giá vé</li>
                </ul>
              </div>
              
              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-3">💡 Mẹo đặt vé thông minh</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Dùng chế độ ẩn danh khi tìm</li>
                  <li>• Theo dõi giá 2-3 tuần</li>
                  <li>• Xem xét bay quá cảnh</li>
                  <li>• Đặt vé khứ hồi cùng lúc</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Chỗ ở */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-hotel-bed-line text-green-600"></i>
              Tiết kiệm chi phí lưu trú
            </h2>

            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-8 mb-6">
              <h3 className="text-xl font-semibold mb-4">🏨 Lựa chọn chỗ ở thông minh</h3>
              <div className="grid md:grid-cols-3 gap-4">
                <div className="bg-white rounded-lg p-4 text-center">
                  <div className="text-2xl mb-2">🏨</div>
                  <h4 className="font-medium mb-2">Khách sạn</h4>
                  <p className="text-sm text-gray-600">Đặt qua Booking.com, Agoda để được giảm giá</p>
                </div>
                <div className="bg-white rounded-lg p-4 text-center">
                  <div className="text-2xl mb-2">🏠</div>
                  <h4 className="font-medium mb-2">Airbnb</h4>
                  <p className="text-sm text-gray-600">Tiết kiệm 30-50% cho nhóm đông người</p>
                </div>
                <div className="bg-white rounded-lg p-4 text-center">
                  <div className="text-2xl mb-2">🏕️</div>
                  <h4 className="font-medium mb-2">Hostel</h4>
                  <p className="text-sm text-gray-600">$25-50/đêm tại các thành phố lớn</p>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6">
              <h4 className="font-semibold text-yellow-800 mb-3">💰 Mẹo đặt phòng giá tốt</h4>
              <ul className="space-y-2 text-sm">
                <li>• <strong>Đặt trước 1-2 tháng:</strong> Được giá tốt nhất, nhiều lựa chọn</li>
                <li>• <strong>Ở ngoại thành:</strong> Tiết kiệm 40-60% so với trung tâm</li>
                <li>• <strong>Chọn phòng không bao gồm bữa sáng:</strong> Tự nấu hoặc mua ngoài rẻ hơn</li>
                <li>• <strong>Tham gia chương trình thành viên:</strong> Được ưu đãi, nâng hạng miễn phí</li>
              </ul>
            </div>
          </section>

          {/* Ăn uống */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-restaurant-line text-green-600"></i>
              Tiết kiệm chi phí ăn uống
            </h2>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4">🍽️ Ăn uống thông minh</h4>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start gap-2">
                    <span className="text-green-600">•</span>
                    <div><strong>Food truck:</strong> $5-12/món, chất lượng tốt</div>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-600">•</span>
                    <div><strong>Happy hour:</strong> 3-6PM giảm 30-50%</div>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-600">•</span>
                    <div><strong>Grocery shopping:</strong> Mua đồ ăn về nấu</div>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-600">•</span>
                    <div><strong>Lunch specials:</strong> Rẻ hơn dinner 40%</div>
                  </li>
                </ul>
              </div>

              <div className="bg-red-50 rounded-lg p-6">
                <h4 className="font-semibold text-red-900 mb-4">📱 App giảm giá</h4>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-center gap-2">
                    <span className="text-red-600">📱</span>
                    <div><strong>Groupon:</strong> Giảm 20-50% nhà hàng</div>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-600">📱</span>
                    <div><strong>Yelp:</strong> Check-in được coupon</div>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-600">📱</span>
                    <div><strong>OpenTable:</strong> Đặt bàn có điểm thưởng</div>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-600">📱</span>
                    <div><strong>Restaurant.com:</strong> Voucher $25 chỉ $10</div>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Di chuyển */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-car-line text-green-600"></i>
              Tiết kiệm chi phí di chuyển
            </h2>

            <div className="bg-blue-50 rounded-xl p-8 mb-6">
              <h3 className="text-xl font-semibold mb-6 text-blue-900">🚗 So sánh chi phí di chuyển</h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b-2 border-blue-200">
                      <th className="text-left p-3">Phương tiện</th>
                      <th className="text-left p-3">Chi phí/ngày</th>
                      <th className="text-left p-3">Ưu điểm</th>
                      <th className="text-left p-3">Nhược điểm</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-blue-100">
                      <td className="p-3 font-medium">Thuê xe</td>
                      <td className="p-3">$30-80</td>
                      <td className="p-3">Tự do, đi xa</td>
                      <td className="p-3">Đắt đỗ xe, xăng</td>
                    </tr>
                    <tr className="border-b border-blue-100">
                      <td className="p-3 font-medium">Uber/Lyft</td>
                      <td className="p-3">$40-100</td>
                      <td className="p-3">Tiện lợi, không lo đỗ xe</td>
                      <td className="p-3">Đắt đi xa</td>
                    </tr>
                    <tr className="border-b border-blue-100">
                      <td className="p-3 font-medium">Tàu điện</td>
                      <td className="p-3">$5-15</td>
                      <td className="p-3">Rẻ, đúng giờ</td>
                      <td className="p-3">Hạn chế tuyến</td>
                    </tr>
                    <tr>
                      <td className="p-3 font-medium">Xe bus</td>
                      <td className="p-3">$2-10</td>
                      <td className="p-3">Rẻ nhất</td>
                      <td className="p-3">Chậm, không tiện</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
              <h4 className="font-semibold text-yellow-800 mb-3">🎟️ Pass tiết kiệm cho thành phố</h4>
              <div className="grid md:grid-cols-2 gap-4">
                <ul className="space-y-2 text-sm">
                  <li>• <strong>NYC MetroCard:</strong> $33/7 ngày không giới hạn</li>
                  <li>• <strong>SF Muni Pass:</strong> $25/7 ngày tất cả phương tiện</li>
                  <li>• <strong>Chicago CTA:</strong> $28/7 ngày tàu + bus</li>
                </ul>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>DC Metro Pass:</strong> Tiết kiệm 20% đi lại</li>
                  <li>• <strong>Boston MBTA:</strong> $22/7 ngày không giới hạn</li>
                  <li>• <strong>LA Metro:</strong> $25/7 ngày toàn mạng lưới</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Tham quan */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-camera-line text-green-600"></i>
              Tiết kiệm chi phí tham quan
            </h2>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div className="bg-purple-50 rounded-lg p-6">
                <h4 className="font-semibold text-purple-900 mb-4">🎫 City Pass & Tourist Pass</h4>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-purple-600 mt-1"></i>
                    <div><strong>NYC CityPASS:</strong> $132 thay vì $200+ (tiết kiệm 35%)</div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-purple-600 mt-1"></i>
                    <div><strong>SF CityPASS:</strong> $76 cho 4 điểm tham quan</div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-star-fill text-purple-600 mt-1"></i>
                    <div><strong>Go City Pass:</strong> Linh hoạt 1-7 ngày</div>
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4">🆓 Miễn phí & Giảm giá</h4>
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start gap-2">
                    <i className="ri-gift-line text-green-600 mt-1"></i>
                    <div><strong>Bảo tàng miễn phí:</strong> Smithsonian, Getty Center</div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-gift-line text-green-600 mt-1"></i>
                    <div><strong>Free walking tour:</strong> Tips tự nguyện</div>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-gift-line text-green-600 mt-1"></i>
                    <div><strong>Student discount:</strong> 50% nhiều điểm</div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-indigo-50 border-l-4 border-indigo-500 p-6">
              <h4 className="font-semibold text-indigo-800 mb-3">📅 Lịch miễn phí hàng tháng</h4>
              <ul className="grid md:grid-cols-2 gap-2 text-sm">
                <li>• <strong>Thứ 2 đầu tháng:</strong> Nhiều bảo tàng NYC miễn phí</li>
                <li>• <strong>Bank of America Weekend:</strong> Miễn phí cho khách hàng</li>
                <li>• <strong>Target Free Family Day:</strong> Các bảo tàng trẻ em</li>
                <li>• <strong>Library Events:</strong> Triển lãm, workshop miễn phí</li>
              </ul>
            </div>
          </section>

          {/* Mua sắm */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-shopping-bag-line text-green-600"></i>
              Mẹo mua sắm tiết kiệm
            </h2>

            <div className="bg-gradient-to-r from-pink-50 to-red-50 rounded-xl p-8 mb-6">
              <h3 className="text-xl font-semibold mb-6 text-pink-900">🛍️ Lịch sale trong năm</h3>
              <div className="grid md:grid-cols-3 gap-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-medium text-pink-800 mb-2">Black Friday</h4>
                  <p className="text-sm text-gray-600">Cuối tháng 11 - Giảm 50-80%</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-medium text-pink-800 mb-2">After Christmas</h4>
                  <p className="text-sm text-gray-600">26/12-31/12 - Clearance sale</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-medium text-pink-800 mb-2">Back to School</h4>
                  <p className="text-sm text-gray-600">Tháng 8 - Điện tử, quần áo</p>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-4">🏪 Nơi mua giá tốt</h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Outlet Mall:</strong> Giảm 30-70% hàng hiệu</li>
                  <li>• <strong>Costco/Sam's Club:</strong> Mua số lượng lớn</li>
                  <li>• <strong>TJ Maxx/Marshall's:</strong> Hàng hiệu giảm giá</li>
                  <li>• <strong>Thrift Store:</strong> Hàng cũ chất lượng cao</li>
                </ul>
              </div>

              <div className="bg-teal-50 rounded-lg p-6">
                <h4 className="font-semibold text-teal-900 mb-4">💳 Thẻ tín dụng cashback</h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Chase Freedom:</strong> 5% rotating categories</li>
                  <li>• <strong>Discover It:</strong> 5% quarterly bonus</li>
                  <li>• <strong>Citi Double Cash:</strong> 2% mọi giao dịch</li>
                  <li>• <strong>Capital One Savor:</strong> 4% nhà hàng</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Tổng kết */}
          <section className="mb-12">
            <div className="bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-6 text-center">💰 Tổng kết: Tiết kiệm tối đa</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold mb-4 text-green-100">Chi phí trung bình/ngày:</h3>
                  <ul className="space-y-2 text-sm text-green-100">
                    <li>• <strong>Budget:</strong> $50-80 (hostel, street food)</li>
                    <li>• <strong>Mid-range:</strong> $100-150 (khách sạn 3*, nhà hàng)</li>
                    <li>• <strong>Luxury:</strong> $200+ (khách sạn 4-5*, fine dining)</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-4 text-green-100">Tiết kiệm tối đa:</h3>
                  <ul className="space-y-2 text-sm text-green-100">
                    <li>• Đặt vé sớm: Tiết kiệm 30%</li>
                    <li>• Chọn chỗ ở thông minh: 50%</li>
                    <li>• Ăn uống local: 40%</li>
                    <li>• Dùng public transport: 60%</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Cần tư vấn lập kế hoạch tiết kiệm?</h3>
            <p className="mb-6 text-orange-100">
              Để lại thông tin, chúng tôi sẽ giúp bạn lập kế hoạch du lịch Mỹ tiết kiệm nhất!
            </p>
            <div className="flex flex-col gap-3 max-w-md mx-auto">
              <button className="bg-white text-orange-600 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer">
                Tư vấn miễn phí
              </button>
              <button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-lg text-lg font-semibold border-2 border-white transition-colors whitespace-nowrap cursor-pointer">
                Nhận bảng chi phí chi tiết
              </button>
            </div>
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}
